import { render, staticRenderFns } from "./auth-info.vue?vue&type=template&id=4a8a2d6d&scoped=true&"
import script from "./auth-info.vue?vue&type=script&lang=js&"
export * from "./auth-info.vue?vue&type=script&lang=js&"
import style0 from "./auth-info.vue?vue&type=style&index=0&id=4a8a2d6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a2d6d",
  null
  
)

export default component.exports